var IS_EXPANDED = 'is-expanded';
var NavBarItem = /** @class */ (function () {
    function NavBarItem(element) {
        var _this = this;
        this.element = element;
        this.link = this.element.querySelector('a');
        this.link.addEventListener('click', function (e) {
            _this.element.classList.toggle(IS_EXPANDED);
        });
    }
    NavBarItem.currentlyExpanded = [];
    return NavBarItem;
}());
export default NavBarItem;
